import { useEffect, useRef } from "react";
import "./P2Modal.scss";
import CloseButton from "./close-btn";
import P2Button from "../P2Button/P2Button";
import P2ButtonGroup from "../P2ButtonGroup/P2ButtonGroup";

const P2Modal = ({
  isOpen,
  onCloseModal,
  children,
  variant="default",
  primaryButtonText,
  secondaryButtonText,
  primaryButtonFunction,
  secondaryButtonFunction,
  primaryButtonDisabled = false,
  secondaryButtonDisabled = false,
  title,
  className
}) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Tab" && dialogRef.current) {
        handleTabKey(event, dialogRef.current);
      } else if (event.key === "Escape") {
        onCloseModal();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onCloseModal]);

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && onCloseModal) {
      onCloseModal();
    }
  };

  const handleTabKey = (event, container) => {
    const focusableElements = container.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");

    if (focusableElements.length === 0) {
      event.preventDefault();
    } else {
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  };

  return (
    <dialog ref={dialogRef} className={`polymer-modal-overlay`} onClick={handleOverlayClick} open={isOpen}>
      <div className={`polymer-modal-container ${className}`}>
        <div className="polymer-modal-content">
          <div className="polymer-modal-header">
            {title && <p className="polymer-modal-header-title">{title}</p>}
            {(variant === "close-button" || onCloseModal) && (
              <div>
                <CloseButton onClick={onCloseModal} />
              </div>
            )}
          </div>
          <div className="polymer-modal-contents">{children}</div>
          {variant !== "close-button" && variant === "default" && (
            <P2ButtonGroup>
              {primaryButtonText && primaryButtonFunction && <P2Button variant={"outline-primary"} onClick={primaryButtonFunction} disabled={primaryButtonDisabled}>
                {primaryButtonText}
              </P2Button>}
              {secondaryButtonText && secondaryButtonFunction && <P2Button variant={"primary-1"} onClick={secondaryButtonFunction} disabled={secondaryButtonDisabled}>
                {secondaryButtonText}
              </P2Button>}
            </P2ButtonGroup>
          )}
        </div>
      </div>
    </dialog>
  );
};

export default P2Modal;
